<h1>{{ title.getTitle() }}</h1>
<hr />
<div id="addContent" class="hide-on-print">
  <div id="actionElements">
    @if (vendorId === null) {
      <a routerLink="/clients/edit-client/0" class="btn btn-save btn-sm inline-add-btn mt-2">Add Client</a>
    }
  </div>
</div>
<pcg-table
  #table
  [dataSource]="dataSource"
  [pcgSort]="[['clientId', 'asc']]"
  [columnDefs]="columns"
  [canResetFilters]="true"
  uniqueColumn="clientName"
  identificationColumn="clientId"
  >
  <ng-container cdkColumnDef="clientName">
    <th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>
      {{ columns.get('clientName').displayName }}
    </th>
    <td
      cdk-cell
      *cdkCellDef="let row"
      [attr.data-label]="columns.get('clientName').displayName"
      style="white-space: nowrap"
      >
      <pcg-edit-link (click)="redirectClient(row.clientId)">{{ row.clientName }}</pcg-edit-link>
    </td>
  </ng-container>
  <ng-container cdkColumnDef="letterCode">
    <th cdk-header-cell *cdkHeaderCellDef>
      {{ columns.get('letterCode').displayName }}
    </th>
    <td
      cdk-cell
      *cdkCellDef="let row"
      [attr.data-label]="columns.get('letterCode').displayName"
      style="white-space: nowrap"
      >
      {{ row.letterCode }}
    </td>
  </ng-container>

  <ng-container cdkColumnDef="canDelete">
    <th cdk-header-cell *cdkHeaderCellDef>
      {{ columns.get('canDelete').displayName }}
    </th>
    <td cdk-cell *cdkCellDef="let row" [attr.data-label]="columns.get('canDelete').displayName">
      <pcg-delete-button
        [table]="table"
        [confirmMessage]="'Are you sure you want to delete this client?'"
        [url]="deleteUrl"
        [id]="row.clientId"
        >
      </pcg-delete-button>
    </td>
  </ng-container>
</pcg-table>
